import React from 'react'
import { Input, Card, Checkbox } from 'antd'
import { useFormikContext } from 'formik'
import { FormField, FormGrid } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutAccreditedSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const titlePath = useFieldPath('sections.aboutAccredited.title')
  const htmlPath = useFieldPath('sections.aboutAccredited.html')
  const badgeSrcPath = useFieldPath('sections.aboutAccredited.badgeSrc')
  const badgeAltPath = useFieldPath('sections.aboutAccredited.badgeAlt')
  const showBadgePath = useFieldPath('sections.aboutAccredited.showBadge')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Título</label>
        <Input
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          placeholder="Ex: Curso credenciado pelo SENATRAN"
        />
      </FormField>
      <FormField>
        <label>HTML</label>
        <TextArea
          name={htmlPath}
          value={get(values, htmlPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="HTML com informações de credenciamento"
        />
      </FormField>
      <FormGrid>
        <FormField>
          <label>Badge Src (URL da imagem)</label>
          <Input
            name={badgeSrcPath}
            value={get(values, badgeSrcPath, '')}
            onChange={handleChange}
            placeholder="/images/senatran.svg"
          />
        </FormField>
        <FormField>
          <label>Badge Alt</label>
          <Input
            name={badgeAltPath}
            value={get(values, badgeAltPath, '')}
            onChange={handleChange}
            placeholder="SENATRAN"
          />
        </FormField>
      </FormGrid>
      <FormField>
        <Checkbox
          checked={get(values, showBadgePath, false)}
          onChange={(e) => setFieldValue(showBadgePath, e.target.checked)}
        >
          Mostrar Badge
        </Checkbox>
      </FormField>
    </Card>
  )
}
